export default "__VITE_ASSET__vJ5601IT__"